import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationNamespace } from 'i18n';
import type { PaymentField } from 'types';

import { SBER_QR_PALETTE } from '../../constants/sber-qr-palette.constant';
import type { SberQrCollapseState } from '../../types';
import { SberQrButton } from '../SberQrButton';

type SberQrFieldsListProps = {
  fields: PaymentField[];
  collapseState: SberQrCollapseState;
  onToggle: () => void;
};

export const SberQrFieldsList: React.FC<SberQrFieldsListProps> = ({
  fields,
  collapseState,
  onToggle,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.sber_qr',
  });

  return (
    <>
      <div
        className={cx('sber-details-collapse', {
          'sber-details-collapse--open': collapseState === 'open',
          'sber-details-collapse--closing': collapseState === 'closing',
          'sber-details-collapse--closed': collapseState === 'closed',
        })}
      >
        <dl
          style={{ borderTopColor: SBER_QR_PALETTE.line }}
          className="tw-m-0 tw-border-t tw-border-solid"
        >
          {fields.map((field) => (
            <div
              key={field.name}
              style={{ borderBottomColor: SBER_QR_PALETTE.line }}
              className="tw-grid tw-grid-cols-[1fr_1.6fr] tw-gap-3 tw-py-3 tw-border-b tw-border-solid"
            >
              <dt
                style={{ color: SBER_QR_PALETTE.muted }}
                className="tw-m-0 tw-text-[13px]"
              >
                {field.label}
              </dt>
              <dd
                className="tw-m-0 tw-font-[650] tw-text-right tw-text-[13px]"
                style={{ color: SBER_QR_PALETTE.text }}
              >
                {field.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
      <SberQrButton
        link
        onClick={onToggle}
        label={collapseState === 'open' ? t('hide_details') : t('show_details')}
        className="md:tw-hidden tw-block tw-mt-3 tw-mx-auto tw-text-xs"
      />
    </>
  );
};
